import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { clsx } from 'clsx';
import * as React from 'react';

import styles from './ChatMessageLayout.css';
import { EMessageType } from '../../types/messageType';
import { noop } from '../../utils/noop';

interface IChatMessageLayoutProps {
  messageType: EMessageType;
  onShow?(): void;
}

export const ChatMessageLayout: React.FC<React.PropsWithChildren<IChatMessageLayoutProps>> = ({
  children,
  messageType,
  onShow = noop,
}) => {
  return (
    <ActionAfterViewObserver triggerOnce callback={onShow} wrapper={false} percentVisible={0.5}>
      <div
        className={clsx(styles['message__layout'], styles[`message__layout_type_${messageType}`])}
        data-name="ChatMessageLayout"
      >
        {children}
      </div>
    </ActionAfterViewObserver>
  );
};
